import { render, staticRenderFns } from "./ReturnOrderMerchant.vue?vue&type=template&id=4267cdc0&"
import script from "./ReturnOrderMerchant.vue?vue&type=script&lang=js&"
export * from "./ReturnOrderMerchant.vue?vue&type=script&lang=js&"
import style0 from "./ReturnOrderMerchant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports